import React from "react"
import Pricing from "@views/pricing"
import SEO from "@components/SEO"

const IndexPage = () => (
  <div>
    <SEO
      title="EngineID - Pricing"
      keywords={[
        `engineid`,
        `security`,
        `access to your applications`,
        `password management`,
        `provision to cloud`,
        `permission management`,
        `single sign on`,
        `identity management`,
        `access management`,
      ]}
    />
    <Pricing />
  </div>
)

export default IndexPage
